module.exports = __webpack_public_path__ + "media/body-condition/normal-chubby-ac3b7c50.svg";